import React from 'react';

// Animated water-wave hero strip shown above the map. Uses a scoped <style>
// block (not Tailwind) since the wave shapes are SVG background animations,
// not something utility classes can express.
export default function TitleBanner({ text }) {
  return (
    <div className="title-banner-wrap">
      <style>{`
        .title-banner-wrap {
          width: 100%;
          flex-shrink: 0;
        }
        .title-banner {
          width: 100%;
          height: 90px;
          min-height: 80px;
          background: linear-gradient(180deg, #0081b5 0%, #006892 100%);
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          box-shadow: 0 4px 16px rgba(0, 104, 146, 0.25);
          position: relative;
          overflow: hidden;
        }
        .title-banner p {
          font-size: 1.25rem;
          font-weight: 700;
          margin: 0;
          letter-spacing: 1px;
          text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
          padding: 0 20px;
          text-align: center;
          position: relative;
          z-index: 10;
        }
        .title-banner .wave {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 200%;
          background-repeat: repeat-x;
          background-size: 50% 100%;
        }
        .title-banner .wave1 {
          height: 60px;
          z-index: 1;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 100' preserveAspectRatio='none'%3E%3Cpath d='M0,50 C250,100 250,0 500,50 C750,100 750,0 1000,50 L1000,100 L0,100 Z' fill='%23ccbf9b' fill-opacity='0.25'/%3E%3C/svg%3E");
          animation: titleWave 22s linear infinite;
        }
        .title-banner .wave2 {
          height: 45px;
          z-index: 2;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 100' preserveAspectRatio='none'%3E%3Cpath d='M0,50 C250,100 250,0 500,50 C750,100 750,0 1000,50 L1000,100 L0,100 Z' fill='%23ccbf9b' fill-opacity='0.5'/%3E%3C/svg%3E");
          animation: titleWaveReverse 18s linear infinite;
        }
        .title-banner .wave3 {
          height: 30px;
          z-index: 3;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 100' preserveAspectRatio='none'%3E%3Cpath d='M0,50 C250,100 250,0 500,50 C750,100 750,0 1000,50 L1000,100 L0,100 Z' fill='%23ccbf9b' fill-opacity='1'/%3E%3C/svg%3E");
          animation: titleWave 12s linear infinite;
        }
        @keyframes titleWave {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes titleWaveReverse {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
      <div className="title-banner">
        <p>{text}</p>
        <div className="wave wave1"></div>
        <div className="wave wave2"></div>
        <div className="wave wave3"></div>
      </div>
    </div>
  );
}
